import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/modules/app.module';
import { firebase } from './environments/environment';

if (firebase.production) {
	enableProdMode();
}
const isLocalhost = window.location.hostname === 'localhost';

Sentry.init({
	dsn: 'https://cc65584a7e280edb07fe222b145bb588@o4508904065204224.ingest.us.sentry.io/4508922091012096',
	enabled: !isLocalhost,
	environment: isLocalhost ? 'development' : 'production',
	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
	release: 'major release 2025-03-21',
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	replaysSessionSampleRate: 0.05, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	tracesSampleRate: 1.0, //  Capture 100% of the transactions,
});

Sentry.startSession();

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(error => {
		Sentry.captureException(error, {
			tags: { operation: 'dashboard:bootstrapModule' },
		});
		console.error(error instanceof Error ? error.message : error);
	});
